<div class="row">
    <div class="col-sm-12 padding-0" style="display: flex; justify-content: space-between;">
        <h3 class="col-sm-6"> Visualisation du {{bc.fValide === 2 ? bc.code : "Cxxxxxxxxxx"}} {{this.bc.societe ? '(' + this.bc.societe.code + ')' : ''}}</h3>
        <div class="col-sm-6" style=" justify-content: space-between;">
            
            <button color="default" mat-raised-button type="button" (click)="close()">
                <mat-icon>arrow_back</mat-icon>Retour à la liste
            </button>
            <button *ngIf="(this.bcForm && this.bcForm.get('fValide').value !== 2 && this.bc.status !== 'Clos' && canRelance && bc.status !== 'Brouillon') ? true: false" [color]="'warn'" mat-raised-button
                type="button" (click)="openRelance()">
                <mat-icon> email</mat-icon>Relance validation
            </button>
            <button [color]="'primary'" mat-raised-button
                type="button" (click)="openCycleValidation()">
                <mat-icon>share</mat-icon> Cycle de validation
            </button>
            <app-pdf-bc [bc]="bc"></app-pdf-bc>
            <button [disabled]="this.bc.statusNum < 10"
            color="primary" mat-raised-button type="button" 
            (click)="sendEmail()">
                <mat-icon>email</mat-icon>Envoyer
            </button>
            <button color="warn" mat-raised-button type="button" (click)="lettrageBpInfo()">
                <mat-icon>info</mat-icon>Info lettrage
            </button>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-sm-10 padding-0" id="parent-container">
        <div>
            <app-bc-form 
                [form]="bcForm" 
                [detailBcInfo]="detailBcInfo" 
                [amountHT]="bcLineHTs" 
                [amountTTC]="bcLineTTCs"
                [amountTVA]="bcLineTVAs">
            </app-bc-form>
        </div>        
    </div>

    <div [ngClass]="parentWidth < 576 ? 'padding-0 mb-4' : 'col-sm-2 padding-0'">
        <app-cycles-bc [cycles]="bc.cycleBcs" [title]="bc.fValide === 2 ? bc.code : 'Cxxxxxxxxxx'"></app-cycles-bc> 
    </div>
</div>

<div class="row">
    <mat-card [ngClass]="childHeight < 285 ? 'col-sm-12' : 'col-sm-10'">
        <mat-card-content>
            <app-fixed-bc-line-list-read 
                class="row" 
                [form]="bcForm">
            </app-fixed-bc-line-list-read>
        </mat-card-content>
    </mat-card>
</div>

<div class="row">
    <mat-card [ngClass]="childHeight < 285 ? 'col-sm-12' : 'col-sm-10'">
        <mat-card-content>
            <app-edit-bc-line-list class="row" [form]="bcForm" [modeRead]="true"></app-edit-bc-line-list>
        </mat-card-content>
    </mat-card>
</div>